import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as agreementSelector from './setting.selector';
// import { firstValueFrom } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { Actions, ofType } from '@ngrx/effects';
import { SettingAction } from './setting.action';
import { Setting, TickType } from '@easy-lib/modules/settings';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SettingStore {
	setting$: Observable<Setting> = this.store.select(agreementSelector.getSetting);
	setting = toSignal(this.setting$);
	settingUpdated = this.actions$.pipe(ofType(SettingAction.updated));
	settingResetDone = this.actions$.pipe(ofType(SettingAction.resetDone));

	getPriceChangeFromSettings(price: number): number {
		const tick = this.setting()?.tick?.toString();
		const tickType = this.setting()?.tickType;
		if (tickType == TickType.Amount) return parseInt(tick);
		if (tickType == TickType.Percent) {
			const percentChange = parseFloat(tick);
			const valueChange = Math.round((price * percentChange) / 100);
			return valueChange;
		}
		return 0;
	}

	// async cautionAgreementStatus() {
	// 	return await firstValueFrom(this.store.select(agreementSelector.cautionAgreementStatus));
	// }
	// async baseMarketAgreementStatus() {
	// 	return await firstValueFrom(this.store.select(agreementSelector.baseMarketAgreementStatus));
	// }
	// async walletCardAgreement() {
	// 	return await firstValueFrom(this.store.select(agreementSelector.walletCardAgreement));
	// }
	// async getAgreementById(id: string) {
	// 	return await firstValueFrom(this.store.select(agreementSelector.getAgreementById(id)));
	// }
	constructor(
		private store: Store,
		private actions$: Actions
	) {}
}
